import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ISanityBlockContent } from '@rbi-ctg/menu';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import { copyToClipboard } from '../../../../helpers';
import { SanityBlockContent } from '../../../../typography/sanity-block-content';

const Container = styled.div`
  text-align: center;
`;

const CodeHeader = styled.p`
  font-weight: bold;
  font-size: 0.9rem;
`;

const CodeFooter = styled.p`
  a {
    color: ${Styles.color.white};
    font-weight: bold;
  }
`;

const CodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  background: #9d051f;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
`;

const CodeInput = styled.input`
  font-family: ${Styles.fontFamily.base};
  color: ${Styles.color.white};
  background-color: transparent;
  outline: none;
  width: 100%;
  padding: 0 1rem;
  border: none;
`;

const CopyButton = styled.button`
  background: ${Styles.color.white};
  border: 0;
  height: 30px;
  width: 80px;
  cursor: pointer;
  color: ${Styles.color.primary};
  font-weight: ${Styles.fontWeight.heavy};
  font-family: ${Styles.fontFamily.base};
  &:hover {
    background-color: ${Styles.color.grey.six};
  }
  border-right: 1px solid ${Styles.color.primary};
`;

interface IGameplayPrizeCodeProps {
  code?: string | null;
  rewardKey?: string | null;
  description?: ISanityBlockContent[] | null;
}

export const GameplayPrizeCode: FC<IGameplayPrizeCodeProps> = ({
  code,
  description,
  rewardKey,
}) => {
  const { formatMessage } = useIntl();
  const mParticle = useMParticleContext();
  const handleCopyClick = async () => code && copyToClipboard(code);
  if (!code) {
    return null;
  }
  const onLinkClick = (url: string) => {
    mParticle.logEvent(CustomEventNames.RUTR_PRIZE_URL_CLICKED, EventTypes.Other, {
      rewardUrl: url,
      rewardKey,
    });
  };
  return (
    <Container>
      <CodeHeader>{formatMessage({ id: 'rutrPrizeCodeHeader' })}</CodeHeader>
      <CodeContainer>
        <CodeInput readOnly value={code} />
        <CopyButton onClick={handleCopyClick}>{formatMessage({ id: 'copy' })}</CopyButton>
      </CodeContainer>
      <CodeFooter>
        {description && (
          <SanityBlockContent centered inverted onLinkClick={onLinkClick} content={description} />
        )}
      </CodeFooter>
    </Container>
  );
};
